import React from 'react'
import Icon from 'components/icons/x-mark';
import Button from 'components/commercetools-ui/atoms/button';
import Popup from 'components/commercetools-ui/atoms/popup';

const SaveConfirmationPopup: React.FC<any> = ({isOpen,handleDiscard, handleSaveNContinue, handleClose,disabledSaveNContinue }) => {
    if (!isOpen) return null;
    return (
        <Popup isOpen={isOpen} bodyClassNames="sm:mx-unset max-w-[375px]">
            <div className="break-words p-[25px]">
                <div className="flex">
                    <p className="mt-[27px] whitespace-normal text-gray-700">
                        Changes are not saved. Please save or discard.
                    </p>
                    <div className="cursor-p" onClick={handleClose}>
                        <Icon />
                    </div>
                </div>
                <div className="mt-51 flex justify-between">
                    <Button
                        variant={'secondary'}
                        className="px-2 py-8 text-sm font-medium disabled:border-gray-200"
                        type="button"
                        onClick={(e) => handleSaveNContinue(e)}
                        disabled={disabledSaveNContinue}
                    >
                        Save and continue
                    </Button>
                    <Button
                        variant={'secondary'}
                        className="px-2 py-8 text-sm font-medium"
                        type="button"
                        onClick={handleDiscard}
                    >
                        Discard changes
                    </Button>
                </div>
            </div>
        </Popup>
    );
};

export default SaveConfirmationPopup;
